import React from 'react';

interface CustomIconProps {
  name: string;
  size?: number;
  color?: string;
  className?: string;
}

const CustomIcon: React.FC<CustomIconProps> = ({ 
  name, 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  const getIconContent = (iconName: string) => {
    switch (iconName) {
      case 'arrow-right1':
        return (
          <g clipPath="url(#clip0_96_305)">
            <path 
              d="M1 9L32 9" 
              stroke={color} 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
            <path 
              d="M25 1.41675L32.5833 9.00008L25 16.5834" 
              stroke={color} 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
            <defs>
              <clipPath id="clip0_96_305">
                <rect width="34" height="18" fill="white"/>
              </clipPath>
            </defs>
          </g>
        );
      default:
        return null;
    }
  };

  const getViewBox = (iconName: string) => {
    switch (iconName) {
      case 'arrow-right1':
        return "0 0 34 18";
      default:
        return "0 0 24 24";
    }
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox={getViewBox(name)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {getIconContent(name)}
    </svg>
  );
};

export default CustomIcon;